import { useSearchParams } from "react-router-dom";

import { SearchEntity } from "shared";

export type SearchFilter = "all" | SearchEntity;

const SEARCH_FILTERS: SearchFilter[] = ["all", ...Object.values(SearchEntity)];

const parseFilter = (value: string | null): SearchFilter =>
  SEARCH_FILTERS.find((filter) => filter === value) ?? "all";

const parsePage = (value: string | null) => {
  const page = Number(value);
  if (!Number.isInteger(page) || page < 1) {
    return 1;
  }
  return page;
};

export const useSearchPageParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") ?? "";
  const filter = parseFilter(searchParams.get("entity"));
  const page = parsePage(searchParams.get("page"));

  const replaceParams = (update: (params: URLSearchParams) => void) => {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        update(params);
        return params;
      },
      { replace: true },
    );
  };

  const submitQuery = (nextQuery: string) => {
    replaceParams((params) => {
      const trimmed = nextQuery.trim();
      if (trimmed) {
        params.set("q", trimmed);
      } else {
        params.delete("q");
      }
      params.delete("page");
    });
  };

  const setFilter = (nextFilter: SearchFilter) => {
    replaceParams((params) => {
      if (nextFilter === "all") {
        params.delete("entity");
      } else {
        params.set("entity", nextFilter);
      }
      params.delete("page");
    });
  };

  const setPage = (nextPage: number) => {
    replaceParams((params) => {
      if (nextPage <= 1) {
        params.delete("page");
      } else {
        params.set("page", String(nextPage));
      }
    });
  };

  return { query, filter, page, submitQuery, setFilter, setPage };
};
